module.exports = __webpack_public_path__ + "static/logo.9ff8fc2e.png";


//////////////////
// WEBPACK FOOTER
// /projects/test/staticreact/testeroo/src/logo.png
// module id = 146
// module chunks = 0